/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Tracking_NumberInputs */

const en_samples_tracking_number = /** @type {(inputs: Samples_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking Number`)
};

const es_samples_tracking_number = /** @type {(inputs: Samples_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero de rastreo`)
};

/**
* | output |
* | --- |
* | "Tracking Number" |
*
* @param {Samples_Tracking_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_tracking_number = /** @type {((inputs?: Samples_Tracking_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Tracking_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_tracking_number(inputs)
	return es_samples_tracking_number(inputs)
});